import { useAuth } from "../context/AuthContext";

export function useAiEnabled(): boolean {
  const { user } = useAuth();
  return user?.aiEnabled !== false;
}

export function isAiDisabledError(message?: string): boolean {
  if (!message) return false;
  return message.includes("AI features have been disabled for this company");
}
